import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LogoPage from './screens/LogoPage.jsx';
import LogeIn from './screens/login/LogeIn.jsx';
import Students from './screens/students/Students.jsx';
import Student from './screens/student/Student.jsx';
import Courses from './screens/courses/Courses.jsx';
import Course from './screens/course/Course.jsx';
import Video from './screens/video/Video.jsx';
import QuestionBank from './screens/questionBank/QuestionBank.jsx';
import Exams from './screens/exams/Exams.jsx';
import Paging from './screens/paging/Paging.jsx';
import Generalexams from './screens/generalexams/Generalexams.jsx';
import ChoosefromQuestionBank from './screens/choosefromQuestionBank/ChoosefromQuestionBank.jsx';
import PrintCodes from './screens/printCodes/PrintCodes.jsx';
import AddGroup from './screens/addGroup/AddGroup.jsx';
import Exam from './screens/exam/Exam.jsx';
import ExamInVideo from './screens/examInVideo/ExamInVideo.jsx';
import News from './screens/news/News.jsx';
import Messages from './screens/messages/Messages.jsx';
import GroupStudents from './screens/groupStudents/GroupStudents.jsx';
import UsedCodes from './screens/usedCodes/UsedCodes.jsx';
import ExamInCourse from './screens/examInCourse/ExamInCourse.jsx';
import {setToken,getToken,removeToken} from "./Data/authToken.js"

const PrivateRoute = ({ children }) => {
  const credentials = getToken();
  return credentials ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LogoPage />} />
        <Route path="/login" element={<LogeIn />} />
        <Route path="/paging" element={ <PrivateRoute><Paging /> </PrivateRoute>} />
        <Route path="/students" element={ <PrivateRoute><Students /> </PrivateRoute>} />
        <Route path="/student" element={ <PrivateRoute><Student /> </PrivateRoute>} />
        <Route path="/courses" element={ <PrivateRoute><Courses /> </PrivateRoute>} />
        <Route path="/course" element={ <PrivateRoute><Course /> </PrivateRoute>} />
        <Route path="/video" element={ <PrivateRoute><Video /> </PrivateRoute>} />
        <Route path="/questionBank" element={ <PrivateRoute><QuestionBank /> </PrivateRoute>} />
        <Route path="/exams" element={ <PrivateRoute><Exams /> </PrivateRoute>} />
        <Route path="/exam" element={ <PrivateRoute><Exam /> </PrivateRoute>} />
        <Route path="/generalexams" element={ <PrivateRoute><Generalexams /> </PrivateRoute>} />
        <Route path="/examInVideo" element={ <PrivateRoute><ExamInVideo /> </PrivateRoute>} />
        <Route path="/examincourse" element={ <PrivateRoute><ExamInCourse /> </PrivateRoute>} />
        <Route path="/choosefromQuestionBank" element={ <PrivateRoute><ChoosefromQuestionBank /> </PrivateRoute>} />
        <Route path="/printCodes" element={ <PrivateRoute><PrintCodes /> </PrivateRoute>} />
        <Route path="/usedCodes" element={ <PrivateRoute><UsedCodes /> </PrivateRoute>} />
        <Route path="/addGroup" element={ <PrivateRoute><AddGroup /> </PrivateRoute>} />
        <Route path="/groupStudents" element={ <PrivateRoute><GroupStudents /> </PrivateRoute>} />
        <Route path="/news" element={ <PrivateRoute><News /> </PrivateRoute>} />
        <Route path="/messages" element={ <PrivateRoute><Messages /> </PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
